// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingIcon_container__1pgcH","spin":"LoadingIcon_spin__7VHVJ"};